import { render, staticRenderFns } from "./PoiPopUp.vue?vue&type=template&id=32a49a8a&scoped=true&"
import script from "./PoiPopUp.vue?vue&type=script&lang=js&"
export * from "./PoiPopUp.vue?vue&type=script&lang=js&"
import style0 from "./PoiPopUp.vue?vue&type=style&index=0&id=32a49a8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a49a8a",
  null
  
)

export default component.exports